import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import * as T from './TabelaExtratoStyle';
import { formatDateSystem, formatNumber } from "../../assets/utils";
import { FiSearch, FiChevronsLeft, FiChevronLeft, FiChevronRight, FiChevronsRight } from "react-icons/fi";

const ITEMS_PER_PAGE = 10;

const TabelaExtrato = ({ startDate, endDate }) => {
    const { extracts } = useContext(AuthContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageInput, setPageInput] = useState('1');
    const [searchTerm, setSearchTerm] = useState('');

    const filteredExtracts = (extracts || [])
        .filter(transaction => transaction.amount > 0)
        .filter((transaction) => {
            let dateMatch = true;
            if (startDate && endDate) {
                const transactionDate = new Date(transaction.dateCreated);
                const [startDay, startMonth, startYear] = startDate.split('/');
                const [endDay, endMonth, endYear] = endDate.split('/');

                const start = new Date(`${startYear}-${startMonth}-${startDay}T00:00:00Z`);
                const end = new Date(`${endYear}-${endMonth}-${endDay}T23:59:59Z`);

                dateMatch = transactionDate >= start && transactionDate <= end;
            }

            let searchMatch = true;
            if (searchTerm) {
                const term = searchTerm.toLowerCase();
                searchMatch = 
                    (transaction.description?.toLowerCase().includes(term)) ||
                    (transaction.status?.toString().toLowerCase().includes(term));
            }

            return dateMatch && searchMatch;
        });

    useEffect(() => {
        setCurrentPage(1);
        setPageInput('1');
    }, [searchTerm, startDate, endDate]);

    const totalPages = Math.ceil(filteredExtracts.length / ITEMS_PER_PAGE);
    const currentItems = filteredExtracts.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            setPageInput(pageNumber.toString());
        }
    };

    const handlePageInputChange = (e) => {
        setPageInput(e.target.value);
    };

    const handlePageInputSubmit = (e) => {
        e.preventDefault();
        const page = parseInt(pageInput, 10);
        if (!isNaN(page)) {
            paginate(page);
        }
    };

    const getSign = (type) => {
        return type ? '+' : '-'; // Simples e direto
    };

    return (
        <>
            <T.SearchBarContainer>
                <FiSearch />
                <input 
                    placeholder="Pesquisar por descrição ou status..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </T.SearchBarContainer>

            <T.TabelaWrapper>
                <T.Table>
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Descrição</th>
                            <th>Valor (R$)</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.length > 0 ? (
                            currentItems.map((transaction, index) => (
                                <tr key={transaction.id || index}>
                                    <td data-label="Data">{formatDateSystem(transaction.dateCreated) || 'N/A'}</td>
                                    <td data-label="Descrição">{transaction.description || 'N/A'}</td>
                                    <td 
                                        data-label="Valor"
                                        className={`value-cell ${transaction.addOrWithdraw ? 'positivo' : 'negativo'}`}
                                    >
                                        {getSign(transaction.addOrWithdraw)} {formatNumber(transaction.amount)}
                                    </td>
                                    <td data-label="Status">{transaction.status || 'N/A'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4">Nenhuma transação encontrada.</td>
                            </tr>
                        )}
                    </tbody>
                </T.Table>
            </T.TabelaWrapper>

            {totalPages > 1 && (
                <T.PaginationContainer>
                    <T.PaginationButton onClick={() => paginate(1)} disabled={currentPage === 1}><FiChevronsLeft /></T.PaginationButton>
                    <T.PaginationButton onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}><FiChevronLeft /></T.PaginationButton>

                    <T.PageInfo>
                        Página {currentPage} de {totalPages}
                    </T.PageInfo>
                    
                    <T.PaginationButton onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}><FiChevronRight /></T.PaginationButton>
                    <T.PaginationButton onClick={() => paginate(totalPages)} disabled={currentPage === totalPages}><FiChevronsRight /></T.PaginationButton>
                </T.PaginationContainer>
            )}
        </>
    );
};

export default TabelaExtrato;